function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49 22.5C49 34.9264 38.9264 45 26.5 45C14.0736 45 4 34.9264 4 22.5C4 10.0736 14.0736 0 26.5 0C38.9264 0 49 10.0736 49 22.5ZM36.1486 19.2947C36.5965 16.3008 34.3168 14.6913 31.1995 13.6177L32.2107 9.56205L29.7418 8.94683L28.7574 12.8956C28.1083 12.7338 27.4416 12.5813 26.7793 12.4302L27.7708 8.45546L25.3032 7.84025L24.2914 11.8944C23.7541 11.772 23.2267 11.6511 22.7148 11.5239L22.7176 11.5112L19.3127 10.6611L18.6559 13.2978C18.6559 13.2978 20.4878 13.7176 20.4491 13.7435C21.4491 13.9931 21.6298 14.6548 21.5995 15.1792L20.4477 19.7995C20.5166 19.8171 20.6059 19.8424 20.7043 19.8817C20.6221 19.8613 20.5341 19.8388 20.4434 19.8171L18.8289 26.2893C18.7065 26.593 18.3964 27.0486 17.6974 26.8757C17.722 26.9115 15.9029 26.4278 15.9029 26.4278L14.6772 29.2536L17.8901 30.0545C18.4878 30.2043 19.0736 30.361 19.6502 30.5086L18.6284 34.6106L21.0946 35.2258L22.1064 31.1674C22.7604 31.3446 23.4163 31.5148 24.074 31.6779L23.0656 35.7173L25.5345 36.3325L26.5562 32.2382C30.7663 33.0349 33.9322 32.7135 35.2647 28.9061C36.3385 25.8405 35.2112 24.0722 32.9961 22.9191C34.6093 22.5473 35.8244 21.4863 36.1486 19.2947ZM30.5075 27.204C29.7445 30.2697 24.5824 28.6124 22.9088 28.1969L24.2646 22.7625C25.9381 23.1801 31.3049 24.007 30.5075 27.204ZM31.2712 19.2504C30.575 22.0389 26.2784 20.6222 24.8847 20.2749L26.1139 15.346C27.5077 15.6933 31.9962 16.3415 31.2712 19.2504Z",
  fill: "#D473E3"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 53,
  height: 53,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgTotalPlayers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPlayers);
export default __webpack_public_path__ + "static/media/total-players.2312e5fb.svg";
export { ForwardRef as ReactComponent };